import React from 'react';
import type { WebResult } from '../../api/OasisBackendApi';

interface WebSearchResultCardProps {
  result: WebResult;
  onTrack?: () => void; // Optional callback for tracking
}

const WebSearchResultCard: React.FC<WebSearchResultCardProps> = ({ result, onTrack }) => {
  const handleClick = () => {
    // Track the interaction
    if (onTrack) {
      onTrack();
    }
  };

  return (
    <div 
      className="rounded-lg p-4 transition-all duration-200 hover:scale-[1.02]"
      style={{ 
        backgroundColor: 'var(--rhea-card-bg)',
        border: '1px solid var(--rhea-card-border)'
      }}
    >
      <a 
        href={result.url} 
        target="_blank" 
        rel="noopener noreferrer"
        className="block"
        onClick={handleClick}
      >
        <div className="flex items-start space-x-4">
          {result.profile?.img && (
            <div className="flex-shrink-0">
              <img 
                src={result.profile.img} 
                alt={result.profile.name || 'Profile'} 
                className="w-10 h-10 rounded-full object-cover"
              />
            </div>
          )}
          <div className="flex-1">
            {result.profile?.name && (
              <div style={{ color: 'var(--rhea-text-secondary)' }} className="text-sm mb-1">
                {result.profile.name}
              </div>
            )}
            <h3 
              className="text-lg font-medium mb-2 line-clamp-2 hover:underline"
              style={{ color: 'var(--rhea-accent-primary)' }}
            >
              {result.title || result.url}
            </h3>
            <p 
              className="text-sm line-clamp-3"
              style={{ color: 'var(--rhea-text-secondary)' }}
            >
              {result.text}
            </p>
          </div>
          <div className="flex-shrink-0">
            <svg 
              className="w-5 h-5" 
              fill="none" 
              stroke="currentColor" 
              viewBox="0 0 24 24"
              style={{ color: 'var(--rhea-text-secondary)' }}
            >
              <path 
                strokeLinecap="round" 
                strokeLinejoin="round" 
                strokeWidth={2} 
                d="M10 6H6a2 2 0 00-2 2v10a2 2 0 002 2h10a2 2 0 002-2v-4M14 4h6m0 0v6m0-6L10 14" 
              />
            </svg>
          </div>
        </div>
      </a>
    </div>
  );
};

export default WebSearchResultCard; 